import { useDispatch } from "react-redux";
import { addItem, removeItem, resetItems } from "..";

export const useExceptionItemActions = () => {
  const dispatch = useDispatch();

  return {
    add: (item: Parameters<typeof addItem>[0]) => dispatch(addItem(item)),
    remove: (index: number) => dispatch(removeItem(index)),
    reset: () => dispatch(resetItems()),
  };
};
